import React, { useState } from 'react';
import { LayoutDashboard, Mail, Users2, Plus, Zap, BellRing, CalendarClock, CalendarDays } from 'lucide-react';
import { NlDashboard } from './NlDashboard';
import { NlCampaigns } from './NlCampaigns';
import { NlEditor } from './NlEditor';
import { NlDetail } from './NlDetail';
import { NlSegments } from './NlSegments';
import { NlAutomations } from './NlAutomations';
import { RelanceTab } from '../RelanceTab';
import { EditorialProgram } from './EditorialProgram';
import { EditorialPlanning } from './EditorialPlanning';
import axios from 'axios';
import { API } from './nlShared';

const NAV = [
  { id: 'dashboard', label: 'Vue d\'ensemble', icon: LayoutDashboard },
  { id: 'campaigns', label: 'Campagnes', icon: Mail },
  { id: 'automations', label: 'Automatisations', icon: Zap },
  { id: 'editorial', label: 'Programme IA', icon: CalendarClock },
  { id: 'planning', label: 'Planning', icon: CalendarDays },
  { id: 'relances', label: 'Relances', icon: BellRing },
  { id: 'segments', label: 'Segments', icon: Users2 },
];

export function NewsletterStudio({ theme }) {
  const light = theme === 'light';
  const [view, setView] = useState({ page: 'dashboard' });

  const newCampaign = async () => {
    const { data } = await axios.post(`${API}/admin/nl/campaigns`, {}, { withCredentials: true });
    setView({ page: 'editor', id: data.id });
  };

  if (view.page === 'editor') return <NlEditor theme={theme} campaignId={view.id} autoMode={!!view.auto} onExit={() => setView({ page: view.auto ? 'automations' : 'campaigns' })} />;
  if (view.page === 'detail') return <NlDetail theme={theme} campaignId={view.id} onExit={() => setView({ page: 'campaigns' })} onEdit={(id) => setView({ page: 'editor', id })} />;

  return (
    <div data-testid="newsletter-studio">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
        <div>
          <h1 className={`text-2xl font-bold ${light ? 'text-gray-900' : 'text-white'}`}>Newsletter Studio</h1>
          <p className={`text-sm mt-0.5 ${light ? 'text-gray-500' : 'text-white/50'}`}>Créez, envoyez et analysez vos campagnes Maya+</p>
        </div>
        <button data-testid="nl-new-campaign-btn" onClick={newCampaign}
          className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-[#E9641A] hover:bg-[#FE975E] text-white text-sm font-bold transition-colors">
          <Plus size={16} /> Nouvelle newsletter
        </button>
      </div>
      <div className={`flex flex-wrap gap-1 mb-6 rounded-lg p-1 w-fit max-w-full ${light ? 'bg-gray-100' : 'bg-white/5'}`}>
        {NAV.map(n => (
          <button key={n.id} data-testid={`nl-nav-${n.id}`} onClick={() => setView({ page: n.id })}
            className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-semibold transition-colors ${
              view.page === n.id ? 'bg-[#E9641A] text-white' : light ? 'text-gray-500 hover:text-gray-900' : 'text-white/50 hover:text-white'}`}>
            <n.icon size={15} /> {n.label}
          </button>
        ))}
      </div>
      {view.page === 'dashboard' && <NlDashboard theme={theme} onOpen={(id) => setView({ page: 'detail', id })} />}
      {view.page === 'campaigns' && <NlCampaigns theme={theme} onOpen={(id) => setView({ page: 'detail', id })} onEdit={(id) => setView({ page: 'editor', id })} />}
      {view.page === 'automations' && <NlAutomations theme={theme} onEditCampaign={(id) => setView({ page: 'editor', id, auto: true })} />}
      {view.page === 'editorial' && <EditorialProgram theme={theme} />}
      {view.page === 'planning' && <EditorialPlanning theme={theme} />}
      {view.page === 'relances' && <RelanceTab theme={theme} />}
      {view.page === 'segments' && <NlSegments theme={theme} />}
    </div>
  );
}
